export default __webpack_public_path__ + "static/media/greek-temple.324c19f7.png";